import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OptimizeImagesService from 'services/OptimizeImages.service';

//import style
import styles from './SmallInfoBox.module.scss';

export default class SmallInfoBoxComponent extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired
  };

  render() {
    const { description, header, logo } = this.props.data;

    return (
      <div className={styles.SmallInfoBox}>
        <div className={`${styles.SmallInfoBoxColumn} ${styles.setMinHeight}`}>
          <div className={styles.SmallInfoBoxLogo}>
            <img src={OptimizeImagesService.adjustImageSize(logo)} alt="logo" />
          </div>
        </div>
        <div className={styles.SmallInfoBoxColumn}>
          <h4>{header}</h4>
        </div>
        <div className={styles.SmallInfoBoxColumn}>
          <p className={styles.SmallInfoBoxDescription}>{description}</p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ChoosenCompany/components/SmallInfoBox/SmallInfoBox.js